function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { UnstyledWidget } from '../../unstyled/widget/UnstyledWidget';
import "./widget.css";

/*
  props
        (string,optional)   classPrepend  The base name of all classes, to make styling specific to an implementation. Default value is 'unstyled'.
        (string,optional)   title         The title of the widget. Default value is an empty string.
        (any,optional)      children      The content to be displayed within the widget.
*/

const Widget = ({
  classPrepend = 'styled',
  title = "",
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledWidget, _extends({
    classPrepend: classPrepend,
    title: title
  }, rest), children);
};
export { Widget };